/** @prettier */
// import styles from './Placeholder.module.scss';

const Placeholder = () => null;

export default Placeholder;
